import { AiComment } from "src/components/AiComment/AiComment";

export type AiCommentBlockProps = {
    editorialPrompt: string;
    isEditing?: boolean;
};

export const AiCommentBlock = (props: AiCommentBlockProps) => {
    const { editorialPrompt, isEditing } = props;

    return <AiComment editorialPrompt={editorialPrompt} isEditing={isEditing} />;
};
